import { render, staticRenderFns } from "./CultureNewMediaRegisterAudit.vue?vue&type=template&id=b4e83914&scoped=true&"
import script from "./CultureNewMediaRegisterAudit.vue?vue&type=script&lang=js&"
export * from "./CultureNewMediaRegisterAudit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e83914",
  null
  
)

export default component.exports